export default () => {
  const init = () => {
    if (!customElements.get('localization-form')) {
      customElements.define(
        'localization-form',
        class LocalizationForm extends HTMLElement {
          constructor() {
            super();
            this.elements = {
              input: this.querySelector('input[name="country_code"]'),
              button: this.querySelector('button.js-localization-form__select'),
              panel: this.querySelector('.js-country-selector'),
              closeButton: this.querySelector(
                '.js-country-selector__close-button',
              ),
              iconCaret: this.querySelector('.js-country-selector__caret'),
            };
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
            this.addEventListener(
              'keydown',
              this.onContainerKeyDown.bind(this),
            );
            this.addEventListener('focusout', this.closeSelector.bind(this));
            this.elements.button.addEventListener(
              'click',
              this.openSelector.bind(this),
            );
            if (this.elements.closeButton) {
              this.elements.closeButton.addEventListener(
                'click',
                this.hidePanel.bind(this),
              );
            }

            this.querySelectorAll('.js-country-selector__option').forEach(
              (item) =>
                item.addEventListener('click', this.onItemClick.bind(this)),
            );
          }

          hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', '');
            this.elements.iconCaret.classList.toggle('-rotate-90');
            this.elements.iconCaret.classList.toggle('rotate-90');
            document.body.classList.remove('overflow-hidden-mobile');
          }

          onContainerKeyDown(event) {
            const focusableItems = Array.from(
              this.querySelectorAll('input'),
            ).filter(
              (item) => !item.parentElement.classList.contains('hidden'),
            );
            let focusedItemIndex = focusableItems.findIndex(
              (item) => item === document.activeElement,
            );
            let itemToFocus;

            // eslint-disable-next-line default-case
            switch (event.code.toUpperCase()) {
              case 'ARROWUP':
                event.preventDefault();
                itemToFocus =
                  focusedItemIndex > 0
                    ? focusableItems[focusedItemIndex - 1]
                    : focusableItems[focusableItems.length - 1];
                itemToFocus.focus();
                break;
              case 'ARROWDOWN':
                event.preventDefault();
                itemToFocus =
                  focusedItemIndex < focusableItems.length - 1
                    ? focusableItems[focusedItemIndex + 1]
                    : focusableItems[0];
                itemToFocus.focus();
                break;
            }

            if (!this.elements.search) return;

            setTimeout(() => {
              focusedItemIndex = focusableItems.findIndex(
                (item) => item === document.activeElement,
              );
              if (focusedItemIndex > -1) {
                this.elements.search.setAttribute(
                  'aria-activedescendant',
                  focusableItems[focusedItemIndex].id,
                );
              } else {
                this.elements.search.setAttribute('aria-activedescendant', '');
              }
            });
          }

          onContainerKeyUp(event) {
            event.preventDefault();

            // eslint-disable-next-line default-case
            switch (event.code.toUpperCase()) {
              case 'ESCAPE':
                if (
                  this.elements.button.getAttribute('aria-expanded') === 'false'
                )
                  return;
                this.hidePanel();
                event.stopPropagation();
                this.elements.button.focus();
                break;
              case 'SPACE':
                if (
                  this.elements.button.getAttribute('aria-expanded') === 'true'
                )
                  return;
                this.openSelector();
                break;
            }
          }

          onItemClick(event) {
            event.stopPropagation();
            const preloader = document.querySelector(
              '[data-localization-preloader]',
            );
            preloader.classList.remove('hidden');
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
          }

          openSelector() {
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute(
              'aria-expanded',
              (
                this.elements.button.getAttribute('aria-expanded') === 'false'
              ).toString(),
            );
            this.elements.iconCaret.classList.toggle('rotate-90');
            this.elements.iconCaret.classList.toggle('-rotate-90');
            if (!document.body.classList.contains('overflow-hidden-tablet')) {
              document.body.classList.add('overflow-hidden-mobile');
            }
            if (window.innerWidth < 1024) {
              this.elements.panel
                .querySelector('.js-country-selector__option')
                .scrollIntoView();
            }
          }

          closeSelector(event) {
            if (
              event.target.classList.contains('js-country-selector__overlay') ||
              !this.contains(event.target) ||
              !this.contains(event.relatedTarget)
            ) {
              this.hidePanel();
            }
          }
        },
      );
    }
  };
  init();
};
